import { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';

import { changeComposeAiGenerated } from 'mastodon/actions/compose';
import { useAppDispatch, useAppSelector } from 'mastodon/store';

// Inline checkbox above the submit button: the author's own declaration
// that the post (text and/or media) is AI-generated. This is the one
// text-side label that is free and never wrong about a person, so it is
// always available. Default unchecked; reset on every successful post.
export const AiGeneratedToggle: React.FC = () => {
  const dispatch = useAppDispatch();
  const checked = useAppSelector((s) => !!s.compose.get('ai_generated'));

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(changeComposeAiGenerated(e.target.checked));
    },
    [dispatch],
  );

  return (
    <label className='compose-form__inline-toggle compose-form__ai-generated'>
      <input
        type='checkbox'
        checked={checked}
        onChange={handleChange}
        data-testid='compose-ai-generated'
      />
      <span>
        <FormattedMessage
          id='compose_form.ai_generated'
          defaultMessage='Contains AI-generated content'
        />
      </span>
    </label>
  );
};
